import React, {useState} from "react";

import axios from "axios";
import "./Weather.css"
import WeatherInfo from "./WeatherInfo";
import WeatherForecast from "./WeatherForecast";


export default function Weather (props) 
{
const [city,setCity]=useState(props.city);
  const [weather, setWeather]=useState({ready:false});

  function handleResponse(response){
    
    setWeather({
      ready: true,
      date: new Date (response.data.dt*1000),
      temperature:response.data.main.temp,
      wind:response.data.wind.speed,
      city:response.data.name,
      country:response.data.sys.country,
      humidity: response.data.main.humidity,
      description:response.data.weather[0].description,
      icon: response.data.weather[0].icon,
    });
  }

function search(){
const apiKey = "cea4eaec36371a8d64cf80cfa988df3d";
let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`
axios.get(apiUrl).then(handleResponse);
}

function handleSubmit(event){
  event.preventDefault();
 search (city);
}

function handleCityChange(event){
setCity(event.target.value);
}

  if (weather.ready){
    return (
     <div className="landing-wrapper">
    <div className="Weather">
      <form onSubmit={handleSubmit}>
        <div className="row">
        <div className="col-9">
        <input type="search"
        placeholder="Enter a city..."
        className="form-control"
        autoFocus="on"
        onChange={handleCityChange}/>
        </div>
        <div className="col-3">
        <input type="submit" value="Search" className="btn btn-primary w-100"/>
      </div>
      </div>
      </form>
      <WeatherInfo data={weather}/>
      <WeatherForecast city={weather.city}/>
    </div>
    </div>);
    }
    else {
  search();
  return "Loading...";}
}
     
//test for Netlify